import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)


// 2. 定义路由
// 每个路由应该映射一个组件。 其中"component" 可以是
// 通过 Vue.extend() 创建的组件构造器，
// 或者，只是一个组件配置对象。
// 我们晚点再讨论嵌套路由。
const routes = [
    { path: '/', component: () => import('@/views/index'), meta: { title: '首页' } },
    { path: '/demo', component: () => import('@/components/HelloWorld'), meta: { title: '首页' } },
    { path: '/swiper', component: () => import('@/components/swiper'), meta: { title: '登录' } },
  { path: '/cut', component: () => import('@/components/cut'), meta: { title: '登录' } },
    { path: '/password', component: () => import('@/components/password'), meta: { title: '登录' } },
]

// 3. 创建 router 实例，然后传 `routes` 配置
// 你还可以传别的配置参数, 不过先这么简单着吧。
const router = new Router({
    mode: 'history',//去掉url中的#
    routes // (缩写) 相当于 routes: routes
})

export default router